module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login-v3 layout-full"
  }, [_c('div', {
    staticClass: "page vertical-align text-xs-center"
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('account.activate.labels.activateYourAccount')))]), _vm._v(" "), (_vm.status == 'link-invalid') ? _c('div', {
    staticClass: "token-invalid"
  }, [_c('alert', {
    attrs: {
      "alertClass": "alert-dismissible",
      "type": "danger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.linkInvalid')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'link-expried') ? _c('div', {
    staticClass: "token-expried"
  }, [_c('alert', {
    attrs: {
      "alertClass": "alert-dismissible",
      "type": "danger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.linkExpired')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'success') ? _c('div', [_c('alert', {
    attrs: {
      "alertClass": "alert-dismissible",
      "type": "success"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.success')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-block btn-link btn-lg btn-submit",
    attrs: {
      "to": ("/" + (this.$route.params.namespace) + "/login")
    }
  }, [_vm._v(_vm._s(_vm.$t('account.activate.action.login')))])], 1) : _vm._e()])], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "/static/images/byteark-loading-white.png",
      "alt": "logo account",
      "width": "180"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "brand-text font-size-24 grey-100"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-copyright page-copyright-inverse"
  }, [_c('p', [_vm._v("Service by ByteArk.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c4e7921!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/ActivateAccount.vue
// module id = 537
// module chunks = 1